export default "__VITE_ASSET__c93a102a__"